export default __webpack_public_path__ + "static/media/iiconos-11.15a91c58.png";